export const initialState = (inputResponse: any, isEdit = false) => {
  return {
    developerId: { value: inputResponse?.developer_name ?? '', id: inputResponse.developerId ?? '', error: '' },
    projectId: { value: inputResponse?.project_name ?? '', id: inputResponse.projectId ?? '', error: '' },
    projecttypeId: { value: inputResponse?.country_name ?? '', id: inputResponse.projecttypeId ?? '', error: '' },
    form_name: { value: inputResponse.form_name ?? '', error: '' },
    leadName: { value: inputResponse.leadName ?? '', error: '' },
    leadEmail: { value: inputResponse.leadEmail ?? '', error: '' },
    leadPhone: { value: inputResponse.leadPhone ?? '', error: '' },
  };
};

export const handleValidation = (rawInput: any) => {

  if (rawInput.developerId.id === '') {
    rawInput.developerId.error = 'Please select developer name';
  }
  if (rawInput.projectId.id === '') {
    rawInput.projectId.error = 'Please select project name';
  }
  if (rawInput.projecttypeId.id === '') {
    rawInput.projecttypeId.error = 'Please select unit type';
  }
  if (rawInput.form_name.value === '') {
    rawInput.form_name.error = 'Please enter form name';
  }
  // if (rawInput.leadName.value === '') {
  //   rawInput.leadName.error = 'Please enter lead name';
  // }
  // if (rawInput.leadEmail.value === '') {
  //   rawInput.leadEmail.error = 'Please enter lead email';
  // }
  // if (rawInput.leadPhone.value === '') {
  //   rawInput.leadPhone.error = 'Please enter lead phone';
  // }
  return rawInput;
};

export const validateInput = (name: any, value: any) => {

  if (name === 'zipcode') {
    if (!/^[0-9]+$/.test(value) || value.length > 6) {
      return false;
    }
  }

  if (name === 'description') {
    if (!/^[a-zA-Z0-9\s.,-]+$/.test(value) && value !== '') {
      return false;
    }
  }

  return true;
};

export const getFinalBodyStructure = (inputBody: any) => {
  let finalBody: any = {};
  for (const key in inputBody) {
    finalBody = { ...finalBody, [key]: ['developerId', 'projectId', 'projecttypeId'].includes(key) ? inputBody[key]?.id : inputBody[key]?.value };
  }
  finalBody.dynamicFields = inputBody.dynamicFields;
  const newObj: any = { ...finalBody };
  return newObj;
};
